import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.css'],
})
export class UserDataComponent {
  lang: string = '';
  userInfo: any = {};
  constructor(private route: ActivatedRoute, private userInfoService: UserInfoService) {
    this.userInfo = this.userInfoService.getUserInfo();
    this.route.params.subscribe((params) => {
      if (params['lang']) {
        this.lang = params['lang'];
      }
    });
  }

  logout() {
    this.userInfoService.logout();
  }
}
